import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section8_1 from "./Section8_1";
import Section8_2 from "./Section8_2";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";


export default function Seo() {
  return (
    <div className="Seo pt-[160px] sm:pt-0">
      <Helmet>
        <title>SEO Services by Expert SEO Agency | Mean3</title>
        <meta
        name="description"
        content="Boost your business with expert SEO services from Mean3. We improve rankings, increase organic traffic, and generate qualified leads that drive revenue."
        />
      </Helmet>
      <Section1 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
      <Section8_1 />
      <Section8_2 />
      <Section11 />
      <Section9 />
      {/* <Section2 /> */}
      <Section10 />
      <Section3 />

    </div>
  );
}
